// extracted by mini-css-extract-plugin
export default {"wrapper":"PendingInviteModal_wrapper__9WJKV","image":"PendingInviteModal_image__jEbpO","text":"PendingInviteModal_text__Nk9IF","name":"PendingInviteModal_name__vRozZ"};